module.exports = __webpack_public_path__ + "img/team-name-3.d31f8d29.png";